import client from '../client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const ENVIRONMENT_COMPARE_BASE_V1 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.ENVIRONMENT,
  VERSIONS.V1,
  'compare',
  false // No tenant ID in the base URL
);

const ENVIRONMENT_EVALUATE_BASE_V1 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.ENVIRONMENT,
  VERSIONS.V1,
  'evaluate', // Resource name for terrestrial evaluation
  false // No tenant ID in the base URL
);

const ENVIRONMENT_FARMLAND_BASE_V2 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.ENVIRONMENT,
  VERSIONS.V2,
  'farmland', // Resource name for terrestrial evaluation
  false // No tenant ID in the base URL
);

const ENVIRONMENT_MONITOR_BASE_V2 = BASE_ENDPOINTS.createEndpoint(
  SERVICES.ENVIRONMENT,
  VERSIONS.V2,
  'monitor', // Resource name for terrestrial evaluation
  false // No tenant ID in the base URL
);

export const getEnvironmentologyComparison = data =>
  client.post(`${ENVIRONMENT_COMPARE_BASE_V1}/`, data);

export const getEnvironmentologyEvaluation = cluster =>
  client.get(`${ENVIRONMENT_EVALUATE_BASE_V1}/${cluster}/`);

export const getEnvironmentData = ({ tenant_id, parent_id, project_ids }) =>
  client.post(`${ENVIRONMENT_FARMLAND_BASE_V2}/`, {
    tenant_id: tenant_id,
    parent_id: parent_id,
    project_ids: project_ids
  });

export const getEnvironmentologyMonitoring = cluster =>
  client.get(`${ENVIRONMENT_MONITOR_BASE_V2}/${cluster}/`);
